<template>
  <div class="h-screen">
    <div class="h-full relative bg-banner">
      <div class="h-full w-full py-10">
        <div class="grid sm:grid-cols-1 text-white h-full relative">
          <div
            class="flex flex-col px-10 items-center justify-center sm:justify-center order-2 gap-32 sm:gap-0"
          >
            <div class="w-full flex justify-center sm:block lg:max-w-xl">
              <img
                src="@/assets/img/hike-logo-main.png"
                class="w-full logo_main-hero mx-auto"
                alt="Hike Society"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-banner {
  background-image: url("@/assets/img/hero-bg.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.187);
}

.bg-banner-video {
  background-color: black;
}

.bg-banner-video video {
  object-fit: cover;
  position: absolute;
  bottom: 0;
}
.logo_main-hero {
  max-width: 320px;
  height: auto;
}

@media (max-width: 767px) {
  .bg-banner {
    background-size: cover;
    background-position: 20% 50%;
  }
  .bg-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.37);
}
  .logo_main-hero {
    max-width: 220px;
  }
}
</style>
